angular.module('picmonic-common').factory('ResourceUpgradeModalService', [
  '$modal',
  function ($modal) {
    return {
      show: function (type, resource) {
        $modal.open({
          templateUrl: '/templates/modals/resources-upgrade.html',
          windowClass: 'pls-modal-resources-upgrade',
          size: 'lg',
          controller: [
            '$rootScope',
            '$scope',
            'MarketOptionsConfig',
            'UserService',
            'PackageOptionsResource',
            function ($rootScope, $scope, MarketOptionsConfig, UserService, PackageOptionsResource) {
              $scope.type = type;
              $scope.resource = resource;
              $scope.base_asset_url = $rootScope.base_asset_url;
              $scope.market = MarketOptionsConfig.getMarketById(UserService.user.lead);
              $scope.marketPlans = PackageOptionsResource.query(
                {
                  market_id: $scope.market.id,
                  group_id: 1,
                },
                function (plans) {
                  $scope.maxPlan = plans[0];

                  angular.forEach(plans, function (plan) {
                    if (plan.price > $scope.maxPlan.price) {
                      $scope.maxPlan = plan;
                    }
                  });
                }
              );
            },
          ],
        });
      },
    };
  },
]);
